module.exports = __webpack_public_path__ + "static/shipment-2609630ad1355f28f3de419e8faa0e9e.png";